import { createApp } from 'vue'
import App from './App.vue'

// Vuetify
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import { createVuetify } from 'vuetify'
//Add the style of Vuetify
import 'vuetify/styles'
import colors from 'vuetify/util/colors'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import axios from 'axios'
import VueExcelXlsx from 'vue-excel-xlsx'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { en, it } from 'vuetify/locale'

import { vueKeycloak } from '@josempgon/vue-keycloak'
import { getToken } from '@josempgon/vue-keycloak'  
import { initRouter } from './router'

const vuetify = createVuetify({
  components: {
    ...components,
    VDateInput
  },
  directives,
  locale: {
    locale: 'it',
    fallback: 'en',
    messages: { en, it },
  },
  theme: {
    defaultTheme:'light',
    themes: {
      dark: {
        dark: true,
        colors: {
          primary: colors.blue.darken1, // #3573e5ff
          secondary: colors.red.lighten4, // #FFCDD2
        }
      },
      light: {
        dark: false,
        colors: {
          primary: colors.blue.darken1, // #3573e5ff
          secondary: colors.red.lighten4, // #FFCDD2
        }
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VBtn: {
      color: 'blue',
      variant: 'outlined',
      rounded: true,
    }
  },
})

var VUE_APP_BACKEND_BASE_URL = '';
var VUE_APP_KEYCLOAK_BASE_URL = '';
var VUE_APP_KEYCLOAK_REALM = '';
var VUE_APP_KEYCLOAK_CLIENT_ID = '';

if (process.env.NODE_ENV === 'development') {
  VUE_APP_BACKEND_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL
  console.log('Running in development mode');
} else {
  console.log('Running in production mode');
}

axios.defaults.baseURL = VUE_APP_BACKEND_BASE_URL;

const backend_api_url = axios.defaults.baseURL + `/api/public/frontend/setup/`;
try {
  const response = await axios.get(backend_api_url); 
  VUE_APP_KEYCLOAK_BASE_URL = response.data.KEYCLOAK_BASE_URL;
  VUE_APP_KEYCLOAK_REALM = response.data.KEYCLOAK_REALM;
  VUE_APP_KEYCLOAK_CLIENT_ID = response.data.KEYCLOAK_CLIENT_ID;
} catch (error) {
  console.error('Error fetching backend API URL:', error);
}

axios.interceptors.request.use(
  async config => {
    const token = await getToken()
    config.headers['Authorization'] = `Bearer ${token}`
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

const vueKeycloakConfig = {
  config: {
    url: VUE_APP_KEYCLOAK_BASE_URL,
    realm: VUE_APP_KEYCLOAK_REALM,
    clientId: VUE_APP_KEYCLOAK_CLIENT_ID,
    flow: 'standard',
    onLoad: 'login-required'
  }
}

const app = createApp(App)
app.use(vuetify)
app.use(VueExcelXlsx)
await vueKeycloak.install(app, vueKeycloakConfig)

const router = initRouter()
app.use(router)

app.mount('#app')

